import React from 'react';
export function Footer() {
  return <footer className="w-full bg-plum-deep px-5 py-9 text-center sm:px-8" data-id="element-90" data-mp="32wd2qgad7ltj">
      <p className="font-sans text-xs text-cream/50" data-id="element-91" data-mp="3ggapns7ja73v">
        © {new Date().getFullYear()} DesbloqueARTE — Todos los derechos reservados
      </p>
    </footer>;
}